import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedAdminRoute: React.FC = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main className="admin-shell grid min-h-screen place-items-center px-4">
        <div className="rounded-2xl border border-[var(--admin-border)] bg-white/80 px-5 py-4 text-sm text-[var(--admin-muted)]">
          Checking admin session...
        </div>
      </main>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedAdminRoute;
